export default __webpack_public_path__ + "static/media/profile.e6c7b118.jpg";